// extracted by mini-css-extract-plugin
export default {"HpBody":"hbody_HpBody__sxY9v","card_para":"hbody_card_para__DJa6D","firstDiv":"hbody_firstDiv__1vcGq","Card_Img":"hbody_Card_Img__Jwd28"};